import { h } from '@stencil/core';
export class RuntimeBaseCell {
  constructor() {
    this.tooltipText = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("div", { class: "runtime-heading" }, h("div", { class: "runtime-heading__label" }, h("slot", null)), this.tooltipText && (h("pdp-icon-tooltip", { class: "runtime-heading__tooltip", icon: "information_stroke", iconSize: "micro", iconColor: "grey", position: "top" }, this.tooltipText))));
  }
  static get is() { return "pes-runtime-heading-cell"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-runtime-heading-cell.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-runtime-heading-cell.css"]
    };
  }
  static get properties() {
    return {
      "tooltipText": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "tooltip-text",
        "reflect": false
      }
    };
  }
  static get elementRef() { return "el"; }
}
